import { ReactNode } from "react";
import { usePermissionCheck } from "../hooks";

/** The `PermissionBoundary` component properties. */
export interface PermissionBoundaryProps {
  
  /** The set of required permissions that the current user must have to display the children. */
  readonly required: ReadonlyArray<string>;

  /** The set of permissions that must not exist to display the children. */
  readonly forbidden?: ReadonlyArray<string>;

  /** The component to display if permissions are not met. */
  readonly error?: React.ComponentType;

  /** The component children. */
  readonly children?: ReactNode;
}

/** The default error component. */
const DefaultError = (): ReactNode => null;

/** A component that displays its children if permissions are met. */
export const PermissionBoundary = (props: PermissionBoundaryProps): ReactNode => {
  const { required, forbidden = [], error: Error = DefaultError, children } = props;

  const hasRequiredPermissions = usePermissionCheck(required);
  const hasForbiddenPermissions = usePermissionCheck(forbidden);

  if (!hasRequiredPermissions || (forbidden.length > 0 && hasForbiddenPermissions)) return <Error />;

  return <>{children}</>;
};
